import React, { useEffect, useState } from 'react';
import '../bot.css'; // Shared CSS for chat UI

const GoogleDialogFlow = ({ config }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const initializeGoogleBot = () => {
      const { projectId, sessionId, languageCode } = config;

      // Validate required fields
      if (!projectId || !sessionId) {
        console.error('Google Dialogflow configuration is incomplete.');
        return;
      }

      // Inject Dialogflow Messenger script
      const dialogflowScript = document.createElement('script');
      dialogflowScript.type = 'text/javascript';
      dialogflowScript.async = true;
      dialogflowScript.src = 'https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1';

      dialogflowScript.onload = () => {
        if (window.dfMessenger) {
          console.error('Dialogflow Messenger is already initialized.');
          return;
        }

        // Initialize Dialogflow Messenger
        const messenger = document.createElement('df-messenger');
        messenger.setAttribute('agent-id', projectId);
        messenger.setAttribute('language-code', languageCode || 'en');
        messenger.setAttribute('session-id', sessionId);

        document.body.appendChild(messenger);

        console.log(`Google Dialogflow bot initialized for project: ${projectId}`);
      };

      document.body.appendChild(dialogflowScript);
    };

    initializeGoogleBot();

    // Add an initial message to the chat if provided
    if (config.initialMsg) {
      setMessages([{ type: 'bot', text: config.initialMsg }]);
    }

    // Cleanup script and messenger on unmount
    return () => {
      const script = document.querySelector(
        'script[src="https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1"]'
      );
      const messenger = document.querySelector('df-messenger');

      if (script) document.body.removeChild(script);
      if (messenger) document.body.removeChild(messenger);

      console.log('Google Dialogflow bot cleaned up.');
    };
  }, [config]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    // Add user's message
    setMessages((prevMessages) => [...prevMessages, { type: 'user', text: input }]);

    // Prepare payload for Google Dialogflow integration (simulated for now)
    const simulatedResponse = "This is a response from Google Dialogflow.";
    setTimeout(() => {
      setMessages((prevMessages) => [
        ...prevMessages,
        { type: 'bot', text: simulatedResponse },
      ]);
    }, 1000);

    setInput(''); // Clear input field
  };

  const toggleChat = () => setIsChatOpen((prev) => !prev);

  return (
    <>
      {/* Instructional Text */}
      <div className="chat-instruction">
        {config.infoText || 'Start chatting with our bot!'}
      </div>

      {/* Chat Open Button */}
      <button
        onClick={toggleChat}
        className="chat-open-button"
        aria-label="Open Chat"
        title="Open Chat"
      >
        💬
      </button>

      {/* Chat Box */}
      {isChatOpen && (
        <div className="aws-lex-bot-container">
          <div className="aws-lex-bot-header">
            {config.closeText || 'Close'}
          </div>

          <div className="aws-lex-bot-messages">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`chat-message ${msg.type}`}
              >
                {msg.type === 'bot' && (
                  <div className="chat-bot-icon">🤖</div>
                )}
                <div className={`chat-bubble ${msg.type}`}>
                  {msg.text}
                </div>
              </div>
            ))}
          </div>

          <div className="aws-lex-bot-input">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') sendMessage();
              }}
              placeholder="Type your message..."
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}
    </>
  );
};

export default GoogleDialogFlow;
